import axios from "axios";
import { useAxiosQuery } from "hooks";

function useUserProfilePicture(
  resourceUrl: string | null | undefined,
  currentUserPicture = false
) {
  const normalizedResourceUrl = resourceUrl?.trim() ?? "";
  const hasResourceUrl = normalizedResourceUrl.length > 0;

  return useAxiosQuery(
    [
      "UserProfilePicture",
      { resourceUrl: normalizedResourceUrl, currentUserPicture },
    ],
    () => axios.get<Blob>(normalizedResourceUrl, { responseType: "blob" }),
    { staleTime: 1 * 60 * 60 * 1000, enabled: hasResourceUrl }
  );
}

export { useUserProfilePicture };
